import React, { ChangeEvent, ReactElement, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { SharedEvents } from '../../../../joint-plus/controller';
import { actionCreator } from '../../../../redux/helpers/actionCreator';

import './index.scss';

interface GroupedOption {
  id: number;
  name: string;
  type: string;
}

interface GroupedSelectProps {
  className?: string;
  placeholder?: string;
  value?: {id: number, type: string};
  onChange?: (event: ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
  options: GroupedOption[];
}

const BATCH_NAME = 'inspector-input';

const GroupedSelect = (props: GroupedSelectProps): ReactElement => {
  const dispatch = useDispatch();
  const [filterInput, setFilterInput] = useState('');
  const [filteredGroups, setFilteredGroups] = useState<Record<string, GroupedOption[]>>({});
  const [showDropdown, setShowDropdown] = useState(false);

  const onFocus = (): void => {
    dispatch(actionCreator(SharedEvents.GRAPH_START_BATCH, BATCH_NAME));
  };

  const onBlur = (): void => {
    dispatch(actionCreator(SharedEvents.GRAPH_STOP_BATCH, BATCH_NAME));
  };

  // Agrupa e filtra mantendo a estrutura de grupos
  const filterAndGroupOptions = (input: string) => {
    const filtered = props.options.filter(option =>
      option.name.toLowerCase().includes(input.toLowerCase())
    );

    // Agrupa os resultados filtrados
    const grouped = filtered.reduce((acc, option) => {
      if (!acc[option.type]) {
        acc[option.type] = [];
      }
      acc[option.type].push(option);
      return acc;
    }, {} as Record<string, GroupedOption[]>);

    setFilteredGroups(grouped);
  };

  // Lógica de filtragem
  const filterOptions = (event: ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    setFilterInput(input);
    filterAndGroupOptions(input);
    props.onChange?.(event as any);
  };

  useEffect(() => {
    // Inicializa com todos os grupos quando o componente monta
    filterAndGroupOptions('');
  }, [props.options]);

  useEffect(() => {
    return () => {
      onBlur();
    };
  }, []);

  useEffect(() => {
    setFilterInput(props?.options?.find(item => (item.id == props?.value?.id && item.type == props?.value?.type))?.name || '');
  }, [props?.options, props?.value]);

  return (
    <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
      <input
        type="text"
        id="filter-input"
        placeholder={props?.placeholder ?? "Digite para filtrar..."}
        value={filterInput}
        onChange={filterOptions}
        onFocus={() => {
          setShowDropdown(true);
          onFocus();
        }}
        onBlur={() => {
          setTimeout(() => setShowDropdown(false), 100);
          onBlur();
        }}
        className='input'
        disabled={props.disabled}
      />

      {showDropdown && (
        <ul className='ul-dropdown'>
          {Object.entries(filteredGroups).map(([type, options]) => (
            <React.Fragment key={type}>
              {/* Mostra o cabeçalho do grupo apenas se houver itens */}
              {options.length > 0 && (
                <li className='li-group-header'>
                  {type === 'variable' ? 'Variáveis' : 'Campos Personalizados'}
                </li>
              )}
              {options.map(option => (
                <li
                  key={option.id}
                  onMouseDown={() => {
                    setFilterInput(option.name);
                    props.onChange?.({
                      target: { value: {id: option.id, type: option.type} } as any
                    } as any);
                    setShowDropdown(false);
                  }}
                  className='li-item-dropdown'
                >
                  {option.name}
                </li>
              ))}
              <br />
              <br />
            </React.Fragment>
          ))}
          
          {/* Mensagem quando não há resultados */}
          {Object.values(filteredGroups).reduce((acc, group) => acc.concat(group), []).length === 0 && (
                <li className='li-item-dropdown no-results'>Nenhum resultado encontrado</li>
            )}
        </ul>
      )}
    </div>
  );
};

export default GroupedSelect;